/* eslint-disable */
import React, { useEffect, useState, Fragment } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import Tooltip from '@material-ui/core/Tooltip'
import Badge from '@material-ui/core/Badge'
import Button from '@material-ui/core/Button'
import classNames from 'classnames'
import { DepartmentItem, DepartmentContainer, DepartmentList } from './styled'

const Department = (props) => {
	const { count, t, department } = props
	const { filter, setFilter } = props.filter
	// useEffect(() => {
	// 	setFilter({ department: [...department.map((x) => x.id)] })
	// }, [department])
	const departmentSaved = localStorage.getItem('department') || null

	async function departmentSavedF() {
		if (departmentSaved !== null) await setFilter({ department: [parseInt(departmentSaved)] })
	}

	useEffect(() => {
		if (props.workflow) {
			departmentSavedF()
		} else {
			setFilter({
				department: props.department.map(x => x.id)
			})
		}
	}, [])

	const all = (Array.isArray(filter.department) &&  Array.isArray(props.department)) && filter.department.length === props.department.length


	function getCount(id) {
		let bot = 0,
			human = 0
		const x =
			Array.isArray(count) && count.length > 0
				? count.filter((x) => x.department_id === id)[0]
				: {}
		x &&
			Object.keys(x).length > 0 &&
			Object.keys(x).map(
				(y) =>
					typeof x[y] === 'object' &&
					Object.keys(x[y]).map(
						(z) =>
							!/\W*(closed)\W*/.test(z) &&
							z !== 'expired' &&
							z !== 'in_day' &&
							z !== 'will_delay' &&
							(!props.auth || props.auth.role > 1 || z !== 'waiting') &&
							(/\W*(bot)\W*/.test(z) ? (bot += x[y][z]) : (human += x[y][z]))
					)
			)
		return filter && filter.type === 'human' ? human : filter.type === 'bot' ? bot : bot + human
	}

	function getCountExpired(id) {
		let expired = false
		const x =
			Array.isArray(count) && count.length > 0
				? count.filter((x) => x.department_id === id)[0]
				: {}
		x &&
			Object.keys(x).length > 0 &&
			Object.keys(x).map(
				(y) =>
					typeof x[y] === 'object' &&
					Object.keys(x[y]).map(
						(z) => z === 'expired' && x[y][z] > 0 && (expired += x[y][z])
					)
			)

		return expired
	}

	function renderName(name) {
		const parts = name.split(' ')
		if (parts.length > 1) {
			return parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
		}
		return parts[0].substr(0, 2).toUpperCase()
	}

	function saveDepartment(value) {
		localStorage.setItem('department', value)
	}

	return (
		<DepartmentContainer>
			<h5 className="department">
				{t.Department.title}
				<button
					onClick={() =>
						setFilter({ department: all ? [] : props.department.map((e) => e.id) })
					}
				>
					<Checkbox checked={all} color="primary" classes={{ root: 'checkbox' }} />
					{t.selectAll}
				</button>
			</h5>
			<DepartmentList>
				{props.department &&
					props.department.map(
						(dept, index) =>
							dept.actived && (
								<DepartmentItem key={`dept_${index}`} color={dept.color}>
									<Tooltip key={dept.id} title={dept.name} placement="bottom">
										<Badge
											badgeContent={count && getCount(dept.id)}
											classes={{
												badge:
													count && getCount(dept.id) > 0
														? 'badge content'
														: 'badge',
											}}
											component="div"
										>
											{getCountExpired(dept.id) > 0 ? (
												<Fragment>
													<div className="badge_expired MuiBadge-badge content MuiBadge-anchorOriginBottomRightRectangle">
														{getCountExpired(dept.id)}
													</div>
													<Button
														onClick={() =>
															setFilter({
																department:
																	filter.department.indexOf(
																		dept.id
																	) > -1
																		? filter.department.filter(
																				(e) => e !== dept.id
																		  )
																		: [
																				...filter.department,
																				dept.id,
																		  ],
															})
														}
														className={classNames({
															active:
																Array.isArray(filter.department) &&
																filter.department.indexOf(dept.id) >
																	-1,
														})}
													>
														{dept.name}
													</Button>
												</Fragment>
											) : (
												<Button
													onClick={() => {
														if (props.workflow) saveDepartment(dept.id)
														setFilter({
															department:
																filter.department.indexOf(dept.id) >
																-1
																	? filter.department.filter(
																			(e) => e !== dept.id
																	  )
																	: [
																			...filter.department,
																			dept.id,
																	  ],
														})
													}}
													className={classNames({
														active:
															Array.isArray(filter.department) &&
															filter.department.indexOf(dept.id) > -1,
													})}
												>
													{dept.name}
												</Button>
											)}
										</Badge>
									</Tooltip>
								</DepartmentItem>
							)
					)}
			</DepartmentList>
		</DepartmentContainer>
	)
}

export default Department
